import { render, staticRenderFns } from "./Meal.vue?vue&type=template&id=0cac3c90&scoped=true&"
import script from "./Meal.vue?vue&type=script&lang=js&"
export * from "./Meal.vue?vue&type=script&lang=js&"
import style0 from "./Meal.vue?vue&type=style&index=0&id=0cac3c90&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cac3c90",
  null
  
)

export default component.exports